import "./insMissingChoiceWidget.scss";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { InsQueryStatedElement } from "../insQueryStatedElement";
import { InsDefaultError } from "../widget-error/InsDefaultError";
import { InsWidgetTitle } from "../widget-title";
import { MissingChoicesEnum } from "./types";
import { InsWidget } from "components";
import { language } from "language/default";
const choices = {
    [MissingChoicesEnum.Compare]: language.en.widget.noComparisonPortfolio,
    [MissingChoicesEnum.PrivateBenchmark]: language.en.modal.privateBenchmarkSelection.noSelectedText
};
export const InsMissingChoiceWidget = (props) => {
    const { widgetId, sectionId, index, choice } = props;
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, errorMode: true, content: React.createElement(InsQueryStatedElement, { hasData: true, queryState: props.state },
            React.createElement("div", { className: "missing-choice-message" }, choices[choice])), title: React.createElement(ErrorBoundary, { FallbackComponent: InsDefaultError },
            React.createElement(InsWidgetTitle, { widgetId: widgetId, sectionId: sectionId, index: index })) });
};
